/* eslint-disable react/prop-types */
import React from 'react';
import { TextField } from '@mui/material';
import DateTimePicker from '../../../../../shared/ui/DateTimePicker/DateTimePicker';
import Autocomplete from '../../../../../shared/ui/Autocomplete/Autocomplete';
import AppUsersAutocomplete from '../components/AppUsersAutocomplete/AppUsersAutocomplete';
import DivisionsAutocomplete from '../components/DivisionsAutocomplete/DivisionsAutocomplete';
import IntervalComponent from '../components/IntervalComponent/IntervalComponent';
import { EMPTY_ERROR, REPORT_PARAMS } from '../constants';

const renderControl = (control, datas, handlers) => {
  const { type, label, code, value, helpData, id, isError, error, isRequired } = control;
  const { companyId, isSchedule } = datas;
  const { handleChangeText, handleChangeDate, handleChangeAutocomplete, handleChangeRange } = handlers;
  switch (type) {
    case REPORT_PARAMS.TEXT:
      return (
        <TextField
          id={id}
          label={label}
          value={value}
          required={Boolean(isRequired)}
          onChange={handleChangeText}
          variant="standard"
          fullWidth
          error={isError}
          helperText={isError ? error || EMPTY_ERROR : null}
        />
      );
    case REPORT_PARAMS.DATETIME:
      return (
        <DateTimePicker
          label={label}
          value={value}
          name={id}
          onChange={handleChangeDate}
          required={Boolean(isRequired)}
        />
      );
    case REPORT_PARAMS.DATE:
      return (
        <DateTimePicker
          label={label}
          value={value}
          name={id}
          onChange={handleChangeDate}
          required={Boolean(isRequired)}
        />
      );
    case REPORT_PARAMS.INTERVAL:
      return (
        <IntervalComponent
          id={id}
          label={label}
          value={typeof value === 'string' ? value.split(/-(?=\d{4}-\d{2}-\d{2}T)/) : value}
          intervalName={helpData?.intervalName}
          onChange={handleChangeRange}
          required={Boolean(isRequired)}
          isSchedule={isSchedule}
        />
      );
    case REPORT_PARAMS.DATE_INTERVAL:
      return (
        <IntervalComponent
          id={id}
          label={label}
          value={typeof value === 'string' ? value.split(/-(?=\d{4}-\d{2}-\d{2}T)/) : value}
          intervalName={helpData?.intervalName}
          onChange={handleChangeRange}
          required={Boolean(isRequired)}
          isSchedule={isSchedule}
          dateOnly
        />
      );
    case REPORT_PARAMS.NUMERIC:
      if (code === 'reportTemplateId') return null;

      return (
        <TextField
          id={id}
          type="number"
          label={label}
          value={value}
          onChange={handleChangeText}
          variant="standard"
          required={Boolean(isRequired)}
        />
      );
    case REPORT_PARAMS.VEHICLE:
      return (
        <Autocomplete
          id={id}
          label={label}
          value={value}
          onChange={handleChangeAutocomplete}
          required={Boolean(isRequired)}
        />
      );
    case REPORT_PARAMS.USER:
      return (
        <AppUsersAutocomplete
          id={id}
          label={label}
          value={value}
          onChange={handleChangeAutocomplete}
          companyId={companyId}
          required={Boolean(isRequired)}
        />
      );
    case REPORT_PARAMS.DIVISION:
      return (
        <DivisionsAutocomplete
          id={id}
          label={label}
          value={value}
          initialDivisionId={helpData?.initialDivisionId}
          onChange={handleChangeAutocomplete}
          companyId={companyId}
          required={Boolean(isRequired)}
        />
      );
    default:
      return null;
  }
};

export default renderControl;
